var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExclusive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 14.567C24.8663 10.7007 31.1337 10.7007 35 14.567",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 19.2337C26.432 17.3017 29.568 17.3017 31.5 19.2337",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.926 31.5H16.3337C13.7553 31.5 11.667 29.4117 11.667 26.8333V8.16667C11.667 5.58833 13.7553 3.5 16.3337 3.5H39.667C42.2453 3.5 44.3337 5.58833 44.3337 8.16667V26.8333C44.3337 29.4117 42.2453 31.5 39.667 31.5H37.0747",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5924 25.6666H32.4078C34.9861 25.6666 37.0744 27.755 37.0744 30.3333V46.6666C37.0744 49.245 34.9861 51.3333 32.4078 51.3333H23.5924C21.0141 51.3333 18.9258 49.245 18.9258 46.6666V30.3333C18.9258 27.755 21.0164 25.6666 23.5924 25.6666Z",
    fill: "#F25926"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0822 44.2507C28.1277 44.2962 28.1277 44.3701 28.0822 44.4157C28.0366 44.4612 27.9627 44.4612 27.9172 44.4157C27.8716 44.3701 27.8716 44.2962 27.9172 44.2507C27.9627 44.2051 28.0366 44.2051 28.0822 44.2507",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclusive);
export default __webpack_public_path__ + "static/media/Exclusive.09c019b165c9ed283e5dea1b4a3e8389.svg";
export { ForwardRef as ReactComponent };